import axios from "@/api/config";

const baseURI = '/utils';
export default {

    getStatisticsData(fields,dateRange) {
        return new Promise((resolve, reject) => {
            resolve(
                axios({
                    url:  baseURI+"/getData",
                    method: 'POST',
                    loading: true,
                    data: {fields: fields, startDate: dateRange[0], endDate: dateRange[1]},
                    target:'article-view'
                })
            )
            reject()
        })
    },

}
